import { TrackedEvents, trackEvent } from 'analytics';
import { useEffect } from 'react';
import { Page } from 'ui';

import { MaterialMatcher } from '../../components/MaterialMatcher/MaterialMatcher';

export const TradingDashboard = () => {
  useEffect(() => {
    trackEvent(TrackedEvents.TRADING_DASHBOARD_VIEW);
  }, []);

  return (
    <Page>
      <Page.Title title="Trading" subtitle="Find matches, send offers and flag to other AMs" />
      <Page.Divider />
      <MaterialMatcher />
    </Page>
  );
};
